import LitigationInvestingBenefits from './LitigationInvestingBenefits';

export default LitigationInvestingBenefits;
